import { useLayoutEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { atom, useAtom } from 'jotai';
import { atomFamily } from 'jotai-family';

type ScrollPosition = {
  x: number;
  y: number;
};

const pageScrollPositions = atomFamily(() =>
  atom<ScrollPosition>({ x: 0, y: 0 })
);

export function useScrollMemory() {
  const { pathname } = useLocation();

  const [pagePosition, setPagePosition] = useAtom(
    pageScrollPositions(pathname)
  );

  const mainElement = useMemo(() => {
    const mainElement = document.querySelector(
      '#root > div > main'
    ) as HTMLElement;
    return mainElement;
  }, []);

  useLayoutEffect(() => {
    // Restore the scroll position for the current page when mounting it.
    // If none was previously saved, the default is simply to scroll to (0, 0).
    mainElement?.scrollTo(pagePosition.x, pagePosition.y);

    return () => {
      // Save the scroll position for the current page when unmounting it.
      // Only do this if the page has actually rendered the main element.
      if (mainElement) {
        const positionToSave = {
          x: mainElement?.scrollLeft,
          y: mainElement?.scrollTop,
        } as ScrollPosition;
        setPagePosition(positionToSave);
      }
    };
  }, [mainElement, pagePosition.x, pagePosition.y, setPagePosition]);
}
